<footer class="footer-block">
    <div class="container">
        <div class="row">
            <div style="min-height: 30px;">
               <div class="footer-links">
                <a href="https://www.honeywell.com/us/en/terms-and-conditions" target="_blank">Terms & Conditions</a>
                <span class="footer-content__bottom-link-border"></span>
                <a href="https://www.honeywell.com/us/en/privacy-statement" target="_blank">Privacy Statement</a>
                <span class="footer-content__bottom-link-border"></span>
                <a href="https://www.honeywell.com/us/en/cookie-notice" target="_blank">Cookie Notice</a>
                <span class="footer-content__bottom-link-border"></span>
                <a href="https://hon-opcenter.my.salesforce-sites.com/PrivacyInformationRequestForm?lang=en" target="_blank">Your Privacy Choices
                    <img src="assets/images/privacyoptions.png" class="footer-icon" alt="icon">
                </a>
                </div>
            </div>
        </div>
    </div>
</footer>